module.exports = __webpack_public_path__ + "img/kda_popstars.db1876a0.jpg";